import Refund from './Refund';
import { RefundContextProvider } from 'contextApi/RefundContext';
import React from 'react';

export default function(props: any) {
  return (
    <RefundContextProvider>
      <Refund {...props} />
    </RefundContextProvider>
  );
}
